import { computed, watch, unref } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { LEGACY_CUSTOM_ATTR_SECTION_KEY } from './eventSectionKeys';

const UI_SETTINGS_KEY = 'event_show_collapsed_sections';

export function useEventSectionCollapse(visibleCustomAttrSectionKeys = null) {
  const { uiSettings, updateUISettings } = useUISettings();

  const collapsedSections = computed(
    () => uiSettings.value[UI_SETTINGS_KEY] || []
  );

  const isSectionCollapsed = key =>
    computed(() => collapsedSections.value.includes(key));

  const toggleSection = key => {
    const current = collapsedSections.value.filter(
      sectionKey => sectionKey !== LEGACY_CUSTOM_ATTR_SECTION_KEY
    );
    const index = current.indexOf(key);
    if (index >= 0) {
      current.splice(index, 1);
    } else {
      current.push(key);
    }
    updateUISettings({ [UI_SETTINGS_KEY]: current });
  };

  const migrateLegacyCollapse = () => {
    if (!visibleCustomAttrSectionKeys) return;

    const current = collapsedSections.value;
    if (!current.includes(LEGACY_CUSTOM_ATTR_SECTION_KEY)) return;

    const customKeys = unref(visibleCustomAttrSectionKeys) || [];
    const migrated = current.filter(
      sectionKey => sectionKey !== LEGACY_CUSTOM_ATTR_SECTION_KEY
    );

    customKeys.forEach(key => {
      if (!migrated.includes(key)) migrated.push(key);
    });

    updateUISettings({ [UI_SETTINGS_KEY]: migrated });
  };

  if (visibleCustomAttrSectionKeys) {
    watch(visibleCustomAttrSectionKeys, migrateLegacyCollapse, {
      immediate: true,
    });
  }

  return {
    isSectionCollapsed,
    toggleSection,
  };
}
